"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = exports.baseRoute = void 0;
exports.baseRoute = '/task-service/relay';
exports.Routes = {
    RELAY: "".concat(exports.baseRoute),
    RELAY_REMOVE: "".concat(exports.baseRoute, "/remove")
};
//# sourceMappingURL=Relay.consts.js.map